module.exports = __webpack_public_path__ + "img/sdc_pic_3.0c4e22d5.jpg";